<template>
  <basic-container class="userinfo-setting-wrapper">
    <avue-tabs :option="optiontab"
               @change="handleChange"></avue-tabs>
    <div v-if="type.prop==='tab1'">
      <avue-form :option="option"
                 v-model="form"
                 @tab-click="handleTabClick"
                 @submit="handleSubmit"></avue-form>
    </div>
    <div v-else-if="type.prop==='tab2'">
      <div class="notice-item"
           v-for="(item,index) in data"
           :key="index">
        <div>
          <div class="name">{{item.title}}</div>
          <div>{{item.subtitle}}</div>
        </div>
        <el-button type="text"
                   @click="updateTab2Handle(index)">修改</el-button>
      </div>
    </div>
    <div v-else-if="type.prop==='tab3'">
      <div class="notice-item"
           v-for="(item,index) in data1"
           :key="index">
        <el-image style="width: 54px; height: 54px"
                  :src="item.img"
                  fit="contain"
                  class="mr15"></el-image>
        <div class="flex-one">
          <div class="name">{{item.title}}</div>
          <div>{{item.subtitle}}</div>
        </div>
        <el-button type="text">修改</el-button>
      </div>
    </div>
    <div v-else-if="type.prop==='tab4'">
      <div class="notice-item"
           v-for="(item,index) in data2"
           :key="index">
        <div>
          <div class="name">{{item.title}}</div>
          <div>{{item.subtitle}}</div>
        </div>
        <el-switch v-model="value">
        </el-switch>
      </div>
    </div>
    <el-dialog title="修改密码"
               :close-on-click-modal="false"
               append-to-body
               width="80%"
               :visible.sync="pwdVisible"
               class="avue-dialog">
      <avue-form :option="pwdOption"
                 ref="pwd"
                 v-model="pwdForm"
                 @submit="updatePasswordHandle"></avue-form>
    </el-dialog>
  </basic-container>
</template>
<script>
import option from "@/option/user/info";
import { getUserInfo, updateInfo, updatePassword } from "@/api/system/user";
import md5 from 'js-md5';
import func from "@/util/func";
let list = [{
  title: '账户密码',
  subtitle: '当前密码强度：强'
}, {
  title: '密保手机',
  subtitle: '已绑定手机：152****1919'
}, {
  title: '密保问题',
  subtitle: '未设置密保问题，密保问题可有效保护账号安全',
}, {
  title: '备用邮箱',
  subtitle: '已绑定邮箱：bjx******@vip.qq.com',
}, {
  title: 'MFA设备/Ukey证书',
  subtitle: '未绑定MFA设备/Ukey证书，绑定后，可以进行二次确认'
}]
let list1 = [{
  img: '/img/bg/img1.png',
  title: '绑定微信',
  subtitle: '当前未绑定微信账号'
}, {
  img: '/img/bg/img2.png',
  title: '绑定手机',
  subtitle: '当前未绑定手机号'
}, {
  img: '/img/bg/img3.png',
  title: '绑定Ukey电子签名证书',
  subtitle: '当前未绑定电子签名证书',
}]
let list2 = [{
  title: '账号密码',
  subtitle: '其他用户的消息将以站内信的形式通知'
}, {
  title: '系统消息',
  subtitle: '系统消息将以站内信的形式通知'
}, {
  title: '待办任务',
  subtitle: '待办任务将以站内信的形式通知',
}]
export default {
  data () {
    return {
      pwdVisible: false,
      pwdForm: {},
      pwdOption: {
        column: [{
          label: '原密码',
          span: 24,
          row: true,
          type: 'password',
          prop: 'oldPassword'
        }, {
          label: '新密码',
          span: 24,
          row: true,
          type: 'password',
          prop: 'newPassword'
        }, {
          label: '确认密码',
          span: 24,
          row: true,
          type: 'password',
          prop: 'newPassword1'
        }]
      },
      type: {},
      optiontab: {
        column: [{
          label: '基本设置',
          prop: 'tab1',
        }, {
          label: '安全设置',
          prop: 'tab2',
        }, {
          label: '账号绑定',
          prop: 'tab3',
        }, {
          label: '消息通知',
          prop: 'tab4',
        }]
      },
      index: 0,
      option: option,
      form: {},
      data: list,
      data1: list1,
      data2: list2,
      option1: {
        props: {
          title: 'title',
          subtitle: 'subtitle',
          tag: 'tag',
        },
      },
      value: false
    };
  },
  created () {
    this.type = this.optiontab.column[0];
    this.handleWitch();
  },
  methods: {
    updateTab2Handle (tab) {
      if (tab == 0) {
        this.pwdVisible = true
      }
    },
    handleChange (column) {
      this.type = column
      // this.$message.success(JSON.stringify(column))
    },
    handleSubmit (form, done) {
      updateInfo(form).then(res => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "修改信息成功!"
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
        done();
      }, error => {
        window.console.log(error);
        done();
      })
    },
    updatePasswordHandle (form, done) {
      updatePassword(md5(form.oldPassword), md5(form.newPassword), md5(form.newPassword1)).then(res => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "修改密码成功!"
          });
          this.$refs.pwd.resetForm()
          this.pwdVisible = false
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
        done();
      }, error => {
        window.console.log(error);
        done();
      })
    },
    handleWitch () {
      if (this.index === 0) {
        getUserInfo().then(res => {
          const user = res.data.data;
          this.form = {
            id: user.id,
            avatar: user.avatar,
            name: user.name,
            realName: user.realName,
            phone: user.phone,
            email: user.email,
          }
        });
      }
    },
    handleTabClick (tabs) {
      this.index = func.toInt(tabs.index);
      this.handleWitch();
    }
  }
};

</script>
<style lang="scss" scoped>
.userinfo-setting-wrapper {
  .notice-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #eaeaea;
    color: #999;

    .name {
      margin-bottom: 6px;
      font-size: 16px;
      color: #333;
    }
  }
}
</style>
